import React, { useEffect, useState } from 'react'
import ExploreCourses from './ExploreCourses'
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import RecommendedCourses from './RecommendedCourses';
import { SET_ONBOARDING_RELATED_PERSONALISED_SKILLS, SET_ONBOARDING_RELATED_SUBJECTS, SET_ONBOARDING_PERSONALISED_SKILLS_LOADING } from '../../redux/actions/types';
import { getRelatedPersonalisedSkills, getRelatedSubjects } from '../../redux/actions/onBoarding';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';

const DomainSelection = ({ handleSetStep }) => {

  const [internalStep , setInternalStep] = useState(0);
  const goal = useSelector((store) => store?.onBoarding?.goal) || "";
  const dispatch = useDispatch();

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_STEP_FIVE_DOMAIN_SELECTION_LOADED);
  }, []);

  useEffect(() => {
    dispatch(getRelatedSubjects(goal, 5, (successObj) => {
      dispatch({type : SET_ONBOARDING_RELATED_SUBJECTS, payload : successObj?.similar_list});
    }, (errorObj) => {
      console.log(errorObj);
    }));

    // Set loading to true before API call
    dispatch({type : SET_ONBOARDING_PERSONALISED_SKILLS_LOADING, payload : true});
    
    dispatch(getRelatedPersonalisedSkills(goal, (successObj) => {
      dispatch({type : SET_ONBOARDING_RELATED_PERSONALISED_SKILLS, payload : successObj?.subject_names});
      // Set loading to false after success
      dispatch({type : SET_ONBOARDING_PERSONALISED_SKILLS_LOADING, payload : false});
    }, (errorObj) => {
      console.log(errorObj);
      // Set loading to false after error
      dispatch({type : SET_ONBOARDING_PERSONALISED_SKILLS_LOADING, payload : false});
    }));
  }, [dispatch, goal]);
  
  return (
        internalStep ===0 ? 
        
        <div className="relative w-full flex-1 flex flex-col items-start justify-start gap-2">
          <div className="text-left text-[24px] font-semibold leading-[125%] text-white">
          To Become A{" "}
            <span className="font-bold">{goal} </span>, Start With One Of This Top Skills
          </div>

          <div className='w-full mt-5 flex-1 flex flex-col justify-between items-center gap-10'>
            <div className='w-full'><RecommendedCourses/></div>
            <div className='w-full flex flex-col justify-center items-center'>
              <div className='w-full text-white text-left font-bold text-[16px]'>
              Didn’t Find What You Need?
              </div>
              <div className='w-full mt-4 relative cursor-pointer' onClick={() => {
                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_EXPLORE_COURSES_BUTTON_CLICKED);
                setInternalStep(1)
              }}>
                  <div className='absolute inset-y-0 left-0 pl-3 flex items-center'>
                      <FontAwesomeIcon icon={faMagnifyingGlass} className={`text-lg text-white/50`}/>
                  </div>
                      <input 
                          type='text'
                          readOnly
                          onClick={() => {
                            Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_EXPLORE_COURSES_BUTTON_CLICKED);
                            setInternalStep(1)
                          }}
                          placeholder='Search any topic you’re interested in'
                          className='w-full bg-[#406AFF]/10 text-white rounded-lg placeholder:text-sm md:placeholder:text-white/50 placeholder:font-medium placeholder:text-white/50 bg-transparent pl-10 border-2  border-[#70AEFF]/50 goal'
                      />
              </div>
              <div className='mt-3 mb-1 text-center text-white/50 text-[12px] underline underline-offset-2 cursor-pointer' onClick={() => setInternalStep(1)}>
              Explore By Category
              </div>
              

            </div>

          </div>
      </div>
        
        
        : <ExploreCourses step={internalStep} setStep={setInternalStep} handleSetStep={handleSetStep}/>
    
    
  )
}

export default DomainSelection